/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_McpInputs */

const en_directory_footer_link_mcp = /** @type {(inputs: Directory_Footer_Link_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP`)
};

const zh_directory_footer_link_mcp = /** @type {(inputs: Directory_Footer_Link_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP`)
};

/**
* | output |
* | --- |
* | "MCP" |
*
* @param {Directory_Footer_Link_McpInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_mcp = /** @type {((inputs?: Directory_Footer_Link_McpInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_McpInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_mcp(inputs)
	return zh_directory_footer_link_mcp(inputs)
});
export { directory_footer_link_mcp as "directory.footer.link_mcp" }